import {createBrowserHistory, History as HistoryType} from 'history';

export let browserHistory: HistoryType | null = null;

export function initHistory(basename: string): void {
    browserHistory = createBrowserHistory({basename});
}
